/* eslint-disable quotes */
import { defineComponent, h } from 'vue';
import { Dialog } from '@phi/components';
import { reduce_and_save_reference_model_to_STL } from '@frontend/import_3d_scan_data';

const body = `<div class='col-sm-12 block-3-box wow fadeInUp'>
    <p class='modal-body-text'>Enter an integer value (e.g. 50)</p>

    <p class='modal-body-bigger-text'>
        <input id='readSTLResizeValue' class='modal-input' autocomplete='off' style='width: 100%;'/>
    </p>

    <div id='readSTLResizeValueCurrentTriangles'></div>

    <label for='readSTLResizeValueSlowCheckbox' class='label label--with-checkbox'>
        <input class='form-control sr-only' style='width: 100%;' type='checkbox' name='proportional' id='readSTLResizeValueSlowCheckbox'>
        <div class='phi-custom-checkbox'>
            <svg class='phi-custom-checkbox__icon' width='16' height='16'>
                <use xlink:href='#arrow-check'></use>
            </svg>
        </div>
        <div class='label__text'>Slower but more accurate</div>
    </label>
</div>`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            close_label: 'Cancel',
            onClose: () => this.$emit('update:show', false),
            confirm_label: 'Resize',
            onConfirm: reduce_and_save_reference_model_to_STL,
            id: 'readSTLResizeValueModal',
            title: 'Amount to resize STL',
            width: 'narrower',
        }, () => h('div', { innerHTML: body }));
    }
});
